<ng-container *ngIf="label; else arialabelonly">
  <label [for]="name" [id]="labelId" class="input-multiselect-label" [attr.aria-label]="ariaPurpose" aria-live="polite"
    >{{ label }}<app-label-icon *ngIf="labelIcon" [data]="labelIcon"
  /></label>
</ng-container>
<ng-template #arialabelonly>
  <label [id]="labelId" class="input-multiselect-label sr-only">{{ ariaPurpose | translateString }}</label>
</ng-template>
<ng-template #defaultTemplate let-option>{{ getLabel(option) }}</ng-template>

<div class="input-multiselect" [style.margin-bottom]="messagePad" [style.width]="width">
  <div class="p-field" [ngClass]="{ left: labelPositionLeft }">
    <p-multiSelect
      appReadOnly
      [name]="name"
      [options]="options"
      #model="ngModel"
      [(ngModel)]="selectedItems"
      [required]="required"
      [placeholder]="placeholder"
      [optionLabel]="optionLabel"
      [optionValue]="optionValue"
      [class.has-errors]="displayErrors"
      (onChange)="onValueChange($event)"
      [disabled]="isDisabled"
      [maxSelectedLabels]="maxSelectedLabels"
      [selectedItemsLabel]="selectedItemsLabel"
      [style.width]="inputWidth"
      [attr.aria-invalid]="displayErrors"
      [attr.aria-describedby]="displayErrors ? name + '-error' : null"
      [showHeader]="showHeader"
      [ignoreReadOnly]="ignoreReadOnly"
    >
      <ng-template let-selectedItems pTemplate="selectedItem">
        <div class="item item-selected" *ngIf="selectedItems">
          <ng-container
            [ngTemplateOutlet]="optionTemplate || defaultTemplate"
            [ngTemplateOutletContext]="{ $implicit: selectedItems, index: i }"
          >
          </ng-container>
        </div>
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="item">
          <ng-container
            [ngTemplateOutlet]="optionTemplate || defaultTemplate"
            [ngTemplateOutletContext]="{ $implicit: item, index: i }"
          >
          </ng-container>
        </div>
      </ng-template>
    </p-multiSelect>
    <div class="error-container" *ngIf="displayErrors" [attr.id]="name + '-error'" role="alert" aria-atomic="true">
      <span *ngFor="let error of errors" class="p-error">{{ error }}</span>
    </div>
  </div>
</div>
